import * as Yup from 'yup';

import type { Id } from '@e-socna/data-layer';

// The quotation emitter of an internal quotation is chosen (the internal actor
// of the sub-mission), the receiver coming from the collaboration.
export const buildSubMissionActorsSchema = (
  internalQuotationWorkflowIds: readonly Id[],
) =>
  Yup.object().shape({
    internalActors: Yup.array()
      .nullable()
      .when('workflowId', {
        is: (workflowId: Id) =>
          internalQuotationWorkflowIds.includes(workflowId),
        then: (schema) =>
          schema.required("Choisissez l'émetteur du devis de la sous-mission"),
      }),
  });
